import React from 'react';
import { ArrowRight, BarChart2, FileCheck, Eye, Download, Shield, TrendingUp } from 'lucide-react';
import './Home.css';

const Home = ({ onEnter, onViewChange }) => {
  return (
    <div className="home-container fade-in" data-testid="home-view">
      <div className="container">
        <div className="hero-section">
          <div className="hero-content" style={{ textAlign: 'center' }}>
            {/* Logo del sistema - grande y centrado, reemplaza el título */}
            <div 
              className="hero-logo" 
              style={{ 
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '2rem'
              }}
            >
              <img 
                src="/logo-alerta360.png" 
                alt="ALERTA 360" 
                style={{ 
                  width: '100%',
                  maxWidth: '550px',
                  height: 'auto',
                  filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.15))'
                }}
                data-testid="hero-title"
              />
            </div>
            
            <p style={{ 
              textAlign: 'center', 
              fontSize: '1.35rem', 
              color: '#555', 
              marginBottom: '1.5rem',
              fontWeight: 500 
            }}>
              Plataforma Integral de Gestión de Alertas y Casos
            </p>

            <p className="hero-description">
              Sistema institucional de la <strong>Comisión Nacional contra la Corrupción (CNC)</strong> 
              destinado a detectar, gestionar, analizar y dar seguimiento a señales tempranas de 
              posibles irregularidades administrativas o hechos vinculados a corrupción, provenientes 
              de diversas fuentes internas y externas.
            </p>

            <div className="hero-badges">
              <span className="badge">5 Módulos Integrados</span>
              <span className="badge">Nomenclatura Única</span>
              <span className="badge">Bitácora Automática</span>
              <span className="badge">Exportación PDF & Excel</span>
              <span className="badge">Tableros Analíticos</span>
            </div>

            <div className="hero-actions">
              <button 
                className="btn btn-primary btn-lg" 
                onClick={() => onViewChange('modulos')}
                data-testid="enter-button"
              >
                <TrendingUp size={20} />
                Ver Módulos
                <ArrowRight size={20} />
              </button>
              <button 
                className="btn btn-secondary btn-lg" 
                onClick={() => onViewChange('gestiones')}
                data-testid="view-detail-button"
              >
                <FileCheck size={20} />
                Ver Gestiones
              </button>
            </div>
          </div>

          <div className="hero-features">
            <div className="feature-card" data-testid="feature-dashboard">
              <div className="feature-icon">
                <BarChart2 size={24} />
              </div>
              <h3>Tablero de Indicadores</h3>
              <p>Visualiza datos con gráficos con datos representativos de la gestión.</p>
            </div>

            <div className="feature-card" data-testid="feature-register">
              <div className="feature-icon">
                <FileCheck size={24} />
              </div>
              <h3>Registro y Validación</h3>
              <p>Campos obligatorios con validación de enlaces HTTP/HTTPS reales y datos consistentes.</p>
            </div>

            <div className="feature-card" data-testid="feature-tracking">
              <div className="feature-icon">
                <Eye size={24} />
              </div>
              <h3>Seguimiento Ágil</h3>
              <p>Estados automáticos (Registrado, Enviado) y manuales (Averiguación, Archivado).</p>
            </div>

            <div className="feature-card" data-testid="feature-export">
              <div className="feature-icon">
                <Download size={24} />
              </div>
              <h3>Reportería Completa</h3>
              <p>Exporta tablero y detalle en PDF/Excel. Genera reportes individuales por post.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
